import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_cover = _resolveComponent("app-cover")!
  const _component_layout_system = _resolveComponent("layout-system")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_TermsAndConditionsPopup = _resolveComponent("TermsAndConditionsPopup")!
  const _component_app_dialog = _resolveComponent("app-dialog")!
  const _component_vue_toast_system = _resolveComponent("vue-toast-system")!
  const _component_vue_dialog_system = _resolveComponent("vue-dialog-system")!
  const _component_popup_root = _resolveComponent("popup-root")!
  const _directive_preloader = _resolveDirective("preloader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      id: "app",
      class: _normalizeClass(["app", _ctx.globalClasses])
    }, [
      _createVNode(_component_app_cover, {
        "is-visible": !_ctx.isAtLeastTablet
      }, null, 8, ["is-visible"]),
      _createVNode(_component_layout_system, {
        show: _ctx.isAtLeastTablet,
        "default-layout": _ctx.LayoutDefault
      }, null, 8, ["show", "default-layout"]),
      (_ctx.isLoading && _ctx.isAtLeastTablet)
        ? (_openBlock(), _createBlock(_component_app_loader, { key: 0 }))
        : _createCommentVNode("", true)
    ], 2)), [
      [_directive_preloader, _ctx.isInlineLoading]
    ]),
    (_ctx.displayTermsAndCondtionsModal)
      ? (_openBlock(), _createBlock(_component_app_dialog, {
          key: 0,
          "require-action": true,
          "is-open": _ctx.displayTermsAndCondtionsModal,
          class: "terms-and-conditions-dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TermsAndConditionsPopup, {
              "on-accept": _ctx.onAccept,
              "on-reject": _ctx.onReject,
              "is-loading": _ctx.isAcceptingTermsAndConditions
            }, null, 8, ["on-accept", "on-reject", "is-loading"])
          ]),
          _: 1
        }, 8, ["is-open"]))
      : _createCommentVNode("", true),
    _createVNode(_component_popup_root, null, {
      default: _withCtx(() => [
        _createVNode(_component_vue_toast_system),
        _createVNode(_component_vue_dialog_system)
      ]),
      _: 1
    })
  ], 64))
}